/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { inAppPurchaseControllerHandleWebhook } from '../fn/in-app-purchase/in-app-purchase-controller-handle-webhook';
import { InAppPurchaseControllerHandleWebhook$Params } from '../fn/in-app-purchase/in-app-purchase-controller-handle-webhook';
import { inAppPurchaseControllerVerifyPurchaseByOriginalAppUserId } from '../fn/in-app-purchase/in-app-purchase-controller-verify-purchase-by-original-app-user-id';
import { InAppPurchaseControllerVerifyPurchaseByOriginalAppUserId$Params } from '../fn/in-app-purchase/in-app-purchase-controller-verify-purchase-by-original-app-user-id';

@Injectable({ providedIn: 'root' })
export class InAppPurchaseService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `inAppPurchaseControllerHandleWebhook()` */
  static readonly InAppPurchaseControllerHandleWebhookPath = '/api/in-app-purchase';

  /**
   * RevenueCat Webhook - LIFETIME purchase.
   *
   * RevenueCat에서 LIFETIME 구매 이벤트를 수신합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `inAppPurchaseControllerHandleWebhook()` instead.
   *
   * This method doesn't expect any request body.
   */
  inAppPurchaseControllerHandleWebhook$Response(params: InAppPurchaseControllerHandleWebhook$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return inAppPurchaseControllerHandleWebhook(this.http, this.rootUrl, params, context);
  }

  /**
   * RevenueCat Webhook - LIFETIME purchase.
   *
   * RevenueCat에서 LIFETIME 구매 이벤트를 수신합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `inAppPurchaseControllerHandleWebhook$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  inAppPurchaseControllerHandleWebhook(params: InAppPurchaseControllerHandleWebhook$Params, context?: HttpContext): Observable<void> {
    return this.inAppPurchaseControllerHandleWebhook$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `inAppPurchaseControllerVerifyPurchaseByOriginalAppUserId()` */
  static readonly InAppPurchaseControllerVerifyPurchaseByOriginalAppUserIdPath = '/api/in-app-purchase/verify-purchase';

  /**
   * Check Lifetime Purchase by transactionId.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `inAppPurchaseControllerVerifyPurchaseByOriginalAppUserId()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  inAppPurchaseControllerVerifyPurchaseByOriginalAppUserId$Response(params: InAppPurchaseControllerVerifyPurchaseByOriginalAppUserId$Params, context?: HttpContext): Observable<StrictHttpResponse<{
}>> {
    return inAppPurchaseControllerVerifyPurchaseByOriginalAppUserId(this.http, this.rootUrl, params, context);
  }

  /**
   * Check Lifetime Purchase by transactionId.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `inAppPurchaseControllerVerifyPurchaseByOriginalAppUserId$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  inAppPurchaseControllerVerifyPurchaseByOriginalAppUserId(params: InAppPurchaseControllerVerifyPurchaseByOriginalAppUserId$Params, context?: HttpContext): Observable<{
}> {
    return this.inAppPurchaseControllerVerifyPurchaseByOriginalAppUserId$Response(params, context).pipe(
      map((r: StrictHttpResponse<{
}>): {
} => r.body)
    );
  }

}
